import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-ink" data-id="element-63" data-mp="3gfitaf6445cj">
      <div className="mx-auto max-w-4xl px-5 pt-[28px] text-center" style={{
      paddingBottom: '25px'
    }} data-id="element-64" data-mp="3gh3sii3dgcgq">
        <p className="font-display text-xl font-black text-white" data-id="element-65" data-mp="36oy1baky1z2l">
          Academia Cemento Elite<span className="align-super text-xs" data-id="element-66" data-mp="3ufa5cad2jbnw">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-white/60" data-id="element-67" data-mp="3ucxok0j1r7cf">
          El sistema de fabricación y venta de objetos en cemento N°1 para emprendedores de
          Argentina. Porque crear un negocio desde casa no debería costarte todos tus ahorros.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/70" data-id="element-68" data-mp="3qbvqhn0v91c1">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors hover:text-gold" data-id="element-69" data-mp="2a19sxkaopkw8">
            <MailIcon className="h-4 w-4 text-cemento" data-id="element-70" data-mp="3labp9pa6nun7" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors hover:text-gold" data-id="element-71" data-mp="3gbqzkjsk4td0">
            <InstagramIcon className="h-4 w-4 text-cemento" data-id="element-72" data-mp="3v8hp81cfiqpf" /> @sigmasmartoficial
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors hover:text-gold" data-id="element-73" data-mp="3q7u1bojhypzf">
            <GlobeIcon className="h-4 w-4 text-cemento" data-id="element-74" data-mp="81pfpjtqwz9w" /> www.sigmasmart.store
          </a>
        </div>

        <p className="mt-4 whitespace-pre-line font-display italic text-gold" style={{
        fontSize: '18px'
      }} data-id="element-75" data-mp="335ph784d1bq">
          {'“Tu emprendimiento con piezas de lujo\nen cemento empieza acá.” 🏺'}
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/40" data-id="element-76" data-mp="cw33b0262240">
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-77" data-mp="qr5heah62xrw">
            Términos y condiciones
          </a>
          <span data-id="element-78" data-mp="tvd0pv9a0bgq">·</span>
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-79" data-mp="tw5xq4ifnmlo">
            Política de privacidad
          </a>
          <span data-id="element-80" data-mp="yupk260xv0ek">·</span>
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-81" data-mp="ys3bc32baeur">
            Soporte
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-white/35" data-id="element-82" data-mp="18jqznv3knfs0">
          © 2026 Sigma Smart™ — Todos los derechos reservados. Prohibida la reproducción y
          redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}